
interface TelemetryInterface {
  selectedEvent: ActivityEvent;
}

import ActivityEvent from '@/models/activityEvent';
import { TelemetryType } from '@/models/enums';
import Vue from 'vue';
import { VueConstructor } from 'vue/types/vue';

const ModelPublishTelemetry = (Vue as VueConstructor<Vue & TelemetryInterface>).extend({
  props: {
    selectedEvent: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      activityEventExpansionPanel: 1,
      jsonString: '',
    };
  },

  watch: {
    selectedEvent() {
      this.jsonString = this.tryFormatJson(this.selectedEvent.activityMetadata);
    },
  },

  methods: {
    getTelemetryType(type: number) {
      return TelemetryType[type];
    },

    copyMetadata() {
      (this.$refs.copyMetadata as HTMLFormElement).select();
      document.execCommand('copy');
    },
  },
});
export default ModelPublishTelemetry;
